import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import utils from '@/jslibs/utils' // getToken from cookie


NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

import siteManage from './modules/site/list';
import ProductManage from './modules/product/list';
import BatteryManage from './modules/battery/list';
import DeviceManage from './modules/device/list';
import EmailManage from './modules/email/list';
import LanguageManage from './modules/language/list';
import AdminManage from './modules/permission/admin';
import RoleManage from './modules/permission/role';
import MenuManage from './modules/permission/menu';
import LogManage from './modules/permission/log';
import TutorialManage from './modules/tutorial/index';
import GuideManage from './modules/guide/list';
import PathManage from './modules/path/list';
import QuestionnaireManage from './modules/questionnaire/list';
import SolutionManage from './modules/solution/list';
import FeedbackManage from './modules/feedback/list';

const Login = () => import('@/pages/Login');
const Index = () => import('@/pages/Index');
Vue.use(Router);

const whiteList = ['/login'] // no redirect whitelist

var children = [
	// 新
	...siteManage,
	...ProductManage,
	...BatteryManage,
	...DeviceManage,
	...EmailManage,
	...LanguageManage,
	...AdminManage,
	...RoleManage,
	...MenuManage,
	...LogManage,
	...TutorialManage,
	...GuideManage,
	...PathManage,
	...QuestionnaireManage,
	...SolutionManage,
	...FeedbackManage
];

const router = new Router({
	routes: [{
		path: '',
		redirect: '/product/list'
	}, {
		path: '/login',
		component: Login
	}, {
		path: '/index',
		component: Index,
		children
	}]
	// mode: 'history',
});


router.beforeEach((to, from, next) => {
	children = [];
	NProgress.start()
	if (utils.getCookie("authorization")) {
		// 已登录且要跳转的页面是登录页
		if (to.path === '/login') {
			//console.log("login")
			next()
			NProgress.done()
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
			NProgress.done()
		}
	}

})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})

export default router;
